import actions from './actions';
import mutations from './mutations';

const state = {
    isProcessing: false,
    upcoming: [],
    attended: []
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
}